import React from "react";
import { Col } from "reactstrap";
import { Link } from "react-router-dom";
import "../../styles/car-item.css";

const CarItem = (props) => {
  const { imgUrl, model, carName, description, speed, price } = props.item;

  return (
    
    <Col lg="3" md="4" sm="6" className="mb-5">
      <div className="car__item">
        <div className="car__img ">
          <img src={imgUrl} alt=""className="w-50 align-items-center" />
        </div>

        <div className="car__item-content  mt-4">
          <h4 className="d-flex align-items-center section_title ">{carName}</h4>
        

          <div className="car__item-info d-flex align-items-center justify-content-center mt-1 mb-4">
            
            <span className=" d-flex section_description gap-1">
               {description}
            </span>
            
          </div>
        <center>
          <button className=" w-50 car__item-btn  car__btn-rent">
            <Link to={`/cars/${carName}`}>See more</Link>
          </button>
          </center>
          {/* <button className=" w-50 car__item-btn car__btn-details">
            <Link to={`/cars/${carName}`} className="details">Details</Link>
          </button> */}
        </div>
      </div>
    </Col>
  );
};

export default CarItem;